import { site } from "@/content/site";

export function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer
      className="relative texture-dark"
      style={{ backgroundColor: "#0a0a0a", color: "#fff" }}
    >
      <div
        aria-hidden="true"
        className="absolute top-0 left-0 right-0"
        style={{ height: 2, backgroundColor: "#d71920" }}
      />
      <div className="container-page py-14 sm:py-18">
        <div className="grid gap-10 md:grid-cols-3 text-center md:text-left">
          <div className="space-y-6 flex flex-col items-center md:items-start">
            <div>
              <h2 className="eyebrow before:hidden">Training</h2>
              <p className="mt-2 text-lg" style={{ color: "rgba(255,255,255,0.8)" }}>
                Monday &ndash; Thursday
              </p>
            </div>
            <div>
              <h2 className="eyebrow before:hidden">Hours</h2>
              <p className="mt-2 text-lg" style={{ color: "rgba(255,255,255,0.8)" }}>
                6:00pm &ndash; 8:00pm
              </p>
            </div>
            <div>
              <h2 className="eyebrow before:hidden">Experience</h2>
              <p className="mt-2 text-lg" style={{ color: "rgba(255,255,255,0.8)" }}>
                No experience necessary
              </p>
            </div>
          </div>

          <div className="flex items-center justify-center">
            <img
              src="/images/membertou-boxing-logo-white.svg"
              alt=""
              width={180}
              height={109}
              decoding="async"
              className="block"
              style={{ opacity: 0.7 }}
            />
          </div>

          <div className="flex flex-col items-center md:items-end md:text-right">
            <h2 className="eyebrow before:hidden">Visit</h2>
            <address className="not-italic mt-3 space-y-4 text-lg" style={{ color: "rgba(255,255,255,0.8)" }}>
              <div>
                {site.contact.address.street}
                <br />
                {site.contact.address.cityRegion}
              </div>
              <div>
                <a
                  href={site.contact.phoneHref}
                  className="text-white underline-offset-4"
                >
                  {site.contact.phone}
                </a>
              </div>
              <div style={{ color: "rgba(255,255,255,0.8)" }}>
                {site.contact.email}
              </div>
            </address>
          </div>
        </div>

        <div className="mt-14 pt-8 flex flex-col items-center gap-4" style={{ borderTop: "1px solid rgba(255,255,255,0.1)" }}>
          <p
            lang="mic"
            aria-label="Ta'n Wen'ju'te'kewinu'k Etl-kina'masulti'tij — Mi'kmaw for Where Warriors Train"
            className="text-center font-display text-lg sm:text-xl not-italic normal-case leading-snug font-medium"
            style={{ color: "#d71920", letterSpacing: "0.08em" }}
          >
            Ta&apos;n Wen&apos;ju&apos;te&apos;kewinu&apos;k Etl-kina&apos;masulti&apos;tij
          </p>
          <p className="text-xs uppercase tracking-[0.2em]" style={{ color: "#fff" }}>
            &mdash; Where Warriors Train &mdash;
          </p>
          <p className="text-xs mt-2" style={{ color: "rgba(255,255,255,0.3)" }}>
            &copy; {year} {site.name}. All rights reserved.
          </p>
          <a
            href="/sitemap.xml"
            className="text-xs no-underline mt-1"
            style={{ color: "rgba(255,255,255,0.2)" }}
          >
            Sitemap
          </a>
        </div>
      </div>
    </footer>
  );
}
